export const indexGenericChannelsWithCapabilitiesById = response => {
  if (!response) return undefined;
  const returnObj = {};
  response.forEach(data => {
    const key = data.genericChannel.id;
    returnObj[key] = data;
  });
  return returnObj;
};